import { PieceViewModel } from "src/app/view-models/orders/piece.view-model";
import { StoredPiece } from "../models/stored-orders/stored-piece";
import { DimensionsMapper } from "./dimensions-mapper";
import { HazmatMapper } from "./hazmat-mapper";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between Piece view model and database StoredPiece.
 */
export class PieceMapper implements IStoredMapper<PieceViewModel, StoredPiece> {
	/** The mapper class for Dimensions data. */
	private readonly dimensionsMapper: DimensionsMapper = new DimensionsMapper();

	/** The mapper class for hazmat data. */
	private readonly hazmatMapper: HazmatMapper = new HazmatMapper();

	/**
	 * Maps a Piece to a StoredPiece.
	 * @param piece The piece data to convert.
	 * @returns A StoredPiece object.
	 */
	public ToStored(piece: PieceViewModel): StoredPiece {
		return {
			PieceId: piece.PieceId,
			DescriptionOfGoods: piece.DescriptionOfGoods,
			Quantity: piece.Quantity,
			ReferenceNumber: piece.ReferenceNumber,
			Dimensions: this.dimensionsMapper.ToStored(piece.Dimensions),
			Hazmat: piece.Hazmat ? this.hazmatMapper.ToStored(piece.Hazmat) : null
		};
	}

	/**
	 * Maps a StoredPiece to a Piece.
	 * @param storedPiece The stored piece data to convert.
	 * @returns A Piece object.
	 */
	public FromStored(storedPiece: StoredPiece): PieceViewModel {
		return {
			PieceId: storedPiece.PieceId,
			DescriptionOfGoods: storedPiece.DescriptionOfGoods,
			Quantity: storedPiece.Quantity,
			ReferenceNumber: storedPiece.ReferenceNumber,
			Dimensions: this.dimensionsMapper.FromStored(storedPiece.Dimensions),
			Hazmat: storedPiece.Hazmat ? this.hazmatMapper.FromStored(storedPiece.Hazmat) : null
		};
	}
}